<div class="header">
  <h3>{{'PRODUCT.LIST.TITLE' | translate}}</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

  <div class="row">
    <div class="col">
      <div class="form-label-group">
        <input class="form-control" type="text" id="product_id" [(ngModel)]="searchProductID"
               placeholder="{{'HISTORY.PRODUCT-ID' | translate}}">
        <label for="product_id">{{'HISTORY.PRODUCT-ID' | translate}}</label>
      </div>
    </div>
    <div class="col">
      <div class="form-label-group">
        <input class="form-control" type="text" id="product_name" [(ngModel)]="searchProductName"
               placeholder="{{'HISTORY.PRODUCT-NAME' | translate}}">
        <label for="product_name">{{'HISTORY.PRODUCT-NAME' | translate}}</label>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <div class="row">
    <div class="col-lg-6 col-md-7 col-xs-12">
      <app-custom-pagination
        [(currentPage)]="currentPage"
        [(itemsPerPage)]="itemsPerPage"
        [totalItems]="totalItems"
        (pageChange)="pageChanged()"
        (optionChange)="optionChanged()"
        *ngIf="loading === false && totalItems !== 0"
      >
      </app-custom-pagination>
    </div>
    <div class="col-lg-6 col-md-5 col-xs-12" style="width: 100%;text-align-last: end;">
      <button type="button" class="btn btn-dv btn-wide mx-1"
        (click)="open(null)">
        {{ 'HISTORY.ADDRESS-ENUM.IMPORT_DATA' | translate }}
      </button>
      <button type="button" class="btn btn-dv btn-wide mx-1"
        (click)="openModal(null, -1)">{{'TEXT.ADD_PRODUCT' | translate}}</button>
    </div>
  </div>
  <div *ngIf="totalItems === 0 && loading === false">
    <div class="col-12 text-center" style="margin: auto">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="scrollable m-t-30">
    <table class="table text-center" *ngIf="totalItems!== 0 && loading === false">
      <thead>
      <tr>
        <th scope="col">{{'COMMON.TABLE.ORDER' | translate}}</th>
        <th scope="col">{{'PRODUCT.LIST.FILTER.PRODUCT-ID' | translate}}</th>
        <th scope="col">{{'PRODUCT.LIST.FILTER.PRODUCT-NAME' | translate}}</th>
        <th scope="col">{{'TABLE.INCLUDING-VAT' | translate}}</th>
        <th scope="col" *ngIf="isAccountantAdmin">{{'TABLE.EDIT' | translate}}</th>
        <th scope="col" *ngIf="isAccountantAdmin">{{'TABLE.DELETE' | translate}}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let product of productDetails; let index = index">
        <td>{{index + 1}}</td>
        <td (click)="openModal(product, product.id)">{{product.product_id}}</td>
        <td>{{product.name_en}}</td>
        <td>
          {{ product.vat }}
          <span *ngIf="product.vat === '7' || product.vat === '0'">%</span>
        </td>
        <td *ngIf="isAccountantAdmin">
          <i class="fa fa-1x fa-edit text-warning pointer" (click)="openModal(product, product.id)"></i>
        </td>
        <td *ngIf="isAccountantAdmin">
          <i class="fa fa-1x fa-trash text-danger pointer" (click)="confirmDelete(index)"></i>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>

<product-list-detail #detailModal></product-list-detail>

<ng-template #deleteConfirmation let-modal>
  <div class="modal-header">
    <h5>{{'COMMON.CONFIRMATION'|translate}}</h5>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h6>{{'NORMAL.PRODUCT-ID'| translate}}: {{ modalData.product_id }}({{modalData.name_en}})</h6>
        <h6>{{'COMMON.CONFIRM-DELETE-PRODUCT'| translate}}</h6>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide"
        (click)="revertBack()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" (click)="confirmedDelete(modalData.id)">
        {{'COMMON.OK' | translate}}
      </button>
    </div>
  </div>
</ng-template>


<ng-template #modalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{"PRODUCT-IMPORT.IMPORT-PRODUCT" | translate}}</h4>
  </div>
  <div class="modal-body box-parent">
    <div class="row">
      <div class="col">
        <div class="rowFix box-parent2 text-center p-t-10">
          <div class="col-12" style='margin-top: 1rem;'>
            <div class="upload-border test-center">
              <div class="inside-text">
                <input type="file" (change)="handleFileInput($event.target.files)" (click)="$event.target.value=null"
                       accept=".csv" id="actual-btn" hidden>
                <label style="background-color: #EEF1F5;padding: 0.5rem;border-radius: 0.3rem;cursor: pointer;"
                       for="actual-btn">{{'PRODUCT-IMPORT.CHOOSE-FILE'|translate}}</label>
                <br><span id="file-chosen">{{chosenFile}}</span>
              </div>
            </div>
            <div *ngIf="fileReport.success" class="text-success text-left">{{ fileReport.success }}<br></div>
            <div *ngIf="fileReport.duplicate" class="text-secondary text-left">{{ fileReport.duplicate }}<br></div>
            <div *ngIf="fileReport.validate_fail">
              <div *ngFor="let validate_error of fileReport.validate_fail" class="text-left">
                <span class="text-danger text-left">{{ validate_error }}</span></div>
            </div>
            <div *ngIf="fileReport.operate_fail">
              <div *ngFor="let operation_error of fileReport.operate_fail" class="text-left">
                <span class="text-danger text-left">{{ operation_error }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-left">
      <a (click)="forTemplate('csv')" class="text-left" style="cursor: pointer;">sample.csv</a></div>
  </div>
  <div class="modal-footer m-b-0">
    <div class="col">
      <div class="row m-b-5"></div>
      <div class="row justify-content-center">
        <div class="col">
          <button class="btn btn-dv btn-clean btn-wide m-r-20" (click)="modal.close()">
            {{'COMMON.CANCEL'|translate}}</button>
        </div>
        <button *ngIf="!complete" class="col-auto btn btn-dv btn-wide pull-right" [disabled]="isSave"
          (click)="submit()">
          <em *ngIf="loading === true" class="fa fa-spinner fa-spin m-r-5"></em>
          {{'TEXT.SAVE'|translate}}</button>
        <button *ngIf="complete" class="col-auto btn btn-dv btn-wide pull-right" (click)="submit()">
          <em *ngIf="loading === true" class="fa fa-spinner fa-spin m-r-5"></em>
          {{'COMMON.COMPLETE'|translate}}</button>
      </div>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list/product-list.component.html